export default "__VITE_ASSET__ocg_r6mg__"